var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"leading-none text-xs overflow-x-scroll scrollbar-hide",class:{
    'bg-white text-primary font-bold': _vm.category.no == _vm.$route.query.category,
  }},[_c('a',{staticClass:"py-4 block text-center",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.switched.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.category.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }